export const TYPE_SMS = "sms"
export const TYPE_EMAIL = "email"


// WEBPACK FOOTER //
// ./src/state/conversation/ConversationThreadTypes.ts